import { __ } from '@wordpress/i18n';

import { ColorPalette } from '@wordpress/block-editor';

import {
	RangeControl,
	TextControl,
	SelectControl,
	HorizontalRule,
} from '@wordpress/components';

const { useEffect } = wp.element;

export const SloganMemberLinkSettings = ({
	attributes,
	setAttributes,
	postTypes,
	posts,
}) => {
	const {
		linkText,
		postType,
		linkedPost,
		linkBorderThickness,
		linkBorderColor,
		linkBorderRadius,
		linkPaddingTopBottom,
		linkPaddingLeftRight,
		linkMarginTop,
		linkBGColor,
		linkColor,
		linkTarget,
	} = attributes;

	// if I deselect postType, ALL attributes should not exist
	// Just reset to their default values as in attributes.js file
	useEffect(() => {
		if (postType === '') {
			setAttributes({
				linkText: 'Read more',
				linkedPost: 0,
				linkBorderThickness: 1,
				linkBorderRadius: 30,
				linkPaddingTopBottom: 5,
				linkPaddingLeftRight: 10,
				linkMarginTop: 10,
				linkBorderColor: '#999999',
				linkBGColor: '#dddddd',
				linkColor: '#444444',
				linkTarget: '_blank',
			});
		}
	}, [postType]);

	return (
		<>
			<SelectControl
				label="Link Type"
				value={postType}
				onChange={(newValue) => {
					setAttributes({
						postType: newValue,
					});
				}}
				options={[
					{
						label: __(
							'Select a post type',
							'wtrb-boxslogan-block'
						),
						value: '',
						disabled: true,
					},
					...(postTypes || []).map((pt) => ({
						label: pt.labels.singular_name,
						value: pt.slug,
					})),
				]}
			/>
			{!!postType && (
				<SelectControl
					label={`Linked ${postType}`}
					value={linkedPost}
					onChange={(newValue) => {
						setAttributes({
							linkedPost: newValue ? parseInt(newValue) : null,
						});
					}}
					options={[
						{
							label: `Select a ${postType} to link to`,
							value: '',
						},
						...(posts || []).map((post) => ({
							label: post.title.rendered,
							value: post.id,
						})),
					]}
				/>
			)}

			<TextControl
				label={__('Link Text', 'wtrb-boxslogan-block')}
				value={linkText}
				onChange={(newValue) =>
					setAttributes({
						linkText: newValue,
					})
				}
			/>

			<div>
				<SelectControl
					label="Link Target"
					value={linkTarget}
					onChange={(newValue) => {
						setAttributes({
							linkTarget: newValue,
						});
					}}
					options={[
						{
							value: '',
							label: __(
								'Select a link target',
								'wtrb-boxslogan-block'
							),
							disabled: true,
						},
						{
							value: '_blank',
							label: __('Blank', 'wtrb-boxslogan-block'),
						},
						{
							value: '_self',
							label: __('Self', 'wtrb-boxslogan-block'),
						},
					]}
					__nextHasNoMarginBottom
				/>
			</div>

			<HorizontalRule />
			<RangeControl
				label={__('Link Border Thickness', 'wtrb-boxslogan-block')}
				value={linkBorderThickness}
				min={1}
				max={10}
				onChange={(newValue) => {
					setAttributes({
						linkBorderThickness: newValue,
					});
				}}
			/>
			<RangeControl
				label={__('Link Border Radius', 'wtrb-boxslogan-block')}
				value={linkBorderRadius}
				min={1}
				max={50}
				onChange={(newValue) => {
					setAttributes({
						linkBorderRadius: newValue,
					});
				}}
			/>
			<RangeControl
				label={__(
					'Link Top-Bottom Padding',
					'wtrb-boxslogan-block'
				)}
				value={linkPaddingTopBottom}
				min={1}
				max={50}
				onChange={(newValue) => {
					setAttributes({
						linkPaddingTopBottom: newValue,
					});
				}}
			/>
			<RangeControl
				label={__(
					'Link Left-Right Padding',
					'wtrb-boxslogan-block'
				)}
				value={linkPaddingLeftRight}
				min={1}
				max={50}
				onChange={(newValue) => {
					setAttributes({
						linkPaddingLeftRight: newValue,
					});
				}}
			/>
			<RangeControl
				label={__('Link Top Margin', 'wtrb-boxslogan-block')}
				value={linkMarginTop}
				min={1}
				max={50}
				onChange={(newValue) => {
					setAttributes({
						linkMarginTop: newValue,
					});
				}}
			/>

			<div>
				<label htmlFor="linkBorderColor">
					{__('Link Border color', 'wtrb-boxslogan-block')}
				</label>
				<ColorPalette
					value={linkBorderColor}
					onChange={(newValue) => {
						setAttributes({
							linkBorderColor: newValue,
						});
					}}
				/>
			</div>
			<div>
				<label htmlFor="linkBGColor">
					{__('Link Background color', 'wtrb-boxslogan-block')}
				</label>
				<ColorPalette
					value={linkBGColor}
					onChange={(newValue) => {
						setAttributes({
							linkBGColor: newValue,
						});
					}}
				/>
			</div>
			<div>
				<label htmlFor="linkColor">
					{__('Link color', 'wtrb-boxslogan-block')}
				</label>
				<ColorPalette
					value={linkColor}
					onChange={(newValue) => {
						setAttributes({
							linkColor: newValue,
						});
					}}
				/>
			</div>
		</>
	);
};
